module.exports = __webpack_public_path__ + "static/img/cont9.4d02e36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont9.jpg
// module id = gehw
// module chunks = 0